import { useNavigate } from "react-router-dom"

export default function withNavigate(WrappedComponent) {
  const WithNavigateWrapper = function (props) {
    const navigate = useNavigate()
    return <WrappedComponent {...{
      ...props,
      navigate,
    }}
    />
  }
  WithNavigateWrapper.displayName = `withNavigate(${WrappedComponent.displayName || WrappedComponent.name})`
  return WithNavigateWrapper
}
